import { Type } from '@angular/core';
import { type ExtractLeafPaths, DASHBOARD_REGISTRY } from '@cumlaude/shared-dashboard-registry';
import { AfwezigheidComponent } from './dashboards/afwezigheid/afwezigheid.component';
import { DocentCijfersDetailsPanelComponent } from './details/docent/docent-cijfers-details-panel/docent-cijfers-details-panel.component';
import { DocentDetailsPanelComponent } from './details/docent/docent-details-panel/docent-details-panel.component';
import { DocentToetsDetailsPanelComponent } from './details/docent/docent-toets-details-panel/docent-toets-details-panel.component';
import { LeerlingAanwezigheidDetailsPanelComponent } from './details/leerling/leerling-aanwezigheid-details-panel/leerling-aanwezigheid-details-panel';
import { LeerlingAfwezigheidDetailsPanelComponent } from './details/leerling/leerling-afwezigheid-details-panel/leerling-afwezigheid-details-panel.component';
import { LeerlingAfwezigheidsredenenDetailsPanelComponent } from './details/leerling/leerling-afwezigheidsredenen-details-panel/leerling-afwezigheidsredenen-details-panel.component';
import { LeerlingBasisvaardighedenDetailsPanelComponent } from './details/leerling/leerling-basisvaardigheden-details-panel/leerling-basisvaardigheden-details-panel.component';
import { LeerlingCijferlijstDetailsPanelComponent } from './details/leerling/leerling-cijferlijst-details-panel/leerling-cijferlijst-details-panel.component';
import { LeerlingDetailsPanelComponent } from './details/leerling/leerling-details-panel/leerling-details-panel.component';
import { LeerlingDoorstroomDetailsPanelComponent } from './details/leerling/leerling-doorstroom-details-panel/leerling-doorstroom-details-panel.component';
import { LeerlingLesregistratiesDetailsPanelComponent } from './details/leerling/leerling-lesregistraties-details-panel/leerling-lesregistraties-details-panel.component';
import { LeerlingLesregistratieredenenDetailsPanelComponent } from './details/leerling/leerling-lesregistratiesredenen-details-panel/leerling-lesregistratieredenen-details-panel.component';
import { LeerlingVakkenDetailsPanelComponent } from './details/leerling/leerling-vakken-details-panel/leerling-vakken-details-panel.component';
import { UitzonderingBovenbouwsuccesComponent } from './dashboards/uitzondering/uitzondering-bovenbouwsucces.component';
import { UitzonderingDoorstroomComponent } from './dashboards/uitzondering/uitzondering-doorstroom.component';
import { UitzonderingEinduitstroomComponent } from './dashboards/uitzondering/uitzondering-einduitstroom.component';
import { UitzonderingOnderbouwsnelheidComponent } from './dashboards/uitzondering/uitzondering-onderbouwsnelheid.component';
import { UitzonderingOnderwijspositieComponent } from './dashboards/uitzondering/uitzondering-onderwijspositie.component';
import { UitzonderingTussentijdseUitstroomComponent } from './dashboards/uitzondering/uitzondering-tussentijdse-uitstroom.component';
import { UitzonderingUitstroomniveauComponent } from './dashboards/uitzondering/uitzondering-uitstroomniveau.component';
import { AanwezigheidDatavolledigheidComponent } from './dashboards/aanwezigheid-datavolledigheid/aanwezigheid-datavolledigheid.component';
import { AanwezigheidOverzichtComponent } from './dashboards/aanwezigheid-overzicht/aanwezigheid-overzicht.component';
import { AanwezigheidStatistiekenComponent } from './dashboards/aanwezigheid-statistieken/aanwezigheid-statistieken.component';
import { BehaaldNiveauConformOPPComponent } from './dashboards/behaald-niveau-conform-opp/behaald-niveau-conform-opp.component';
import { BeoogdIrtBehaaldComponent } from './dashboards/beoogd-irt-behaald/beoogd-irt-behaald.component';
import { BovenbouwsuccesComponent } from './dashboards/bovenbouwsucces/bovenbouwsucces.component';
import { CijferlijstComponent } from './dashboards/cijferlijst/cijferlijst.component';
import { CijfersDocentComponent } from './dashboards/cijfers-docent/cijfers-docent.component';
import { CijfersExamensComponent } from './dashboards/cijfers-examens/cijfers-examens.component';
import { CijfersSeCeComponent } from './dashboards/cijfers-se-ce/cijfers-se-ce.component';
import { CijfersOverzichtComponent } from './dashboards/cijfers-overzicht/cijfers-overzicht.component';
import { CohortdetailsComponent } from './dashboards/cohortdetails/cohortdetails.component';
import { CohortrendementComponent } from './dashboards/cohortrendement/cohortrendement.component';
import { DoorstroomComponent } from './dashboards/doorstroom/doorstroom.component';
import { EinduitstroomComponent } from './dashboards/einduitstroom/einduitstroom.component';
import { ExamencijfersComponent } from './dashboards/examencijfers/examencijfers.component';
import { GeslaagdComponent } from './dashboards/geslaagd/geslaagd.component';
import { InstroomComponent } from './dashboards/instroom/instroom.component';
import { KenmerkComponent } from './dashboards/kenmerk/kenmerk.component';
import { LeerlingComponent } from './dashboards/leerling/leerling.component';
import { LesregistratiesComponent } from './dashboards/lesregistraties/lesregistraties.component';
import { MatrixComponent } from './dashboards/matrix/matrix.component';
import { OnderbouwsnelheidComponent } from './dashboards/onderbouwsnelheid/onderbouwsnelheid.component';
import { OnderwijspositieComponent } from './dashboards/onderwijspositie/onderwijspositie.component';
import { OnderwijsresultatenComponent } from './dashboards/onderwijsresultaten/onderwijsresultaten.component';
import { OvergangComponent } from './dashboards/overgang/overgang.component';
import { PlaatsingAdviesComponent } from './dashboards/plaatsing-advies/plaatsing-advies.component';
import { PrestatieanalyseComponent } from './dashboards/prestatieanalyse/prestatieanalyse.component';
import { ToetsComponent } from './dashboards/toets/toets.component';
import { ToetsDetailsComponent } from './dashboards/toets-details/toets-details.component';
import { TussentijdseUitstroomComponent } from './dashboards/tussentijdse-uitstroom/tussentijdse-uitstroom.component';
import { UitstroomComponent } from './dashboards/uitstroom/uitstroom.component';
import { VakkenComponent } from './dashboards/vakken/vakken.component';
import { VerschilSeCeComponent } from './dashboards/verschil-se-ce/verschil-se-ce.component';
import { BasisvaardigheidOverzichtComponent } from './dashboards/basisvaardigheid-overzicht/basisvaardigheid-overzicht.component';

/**
 * Helper die TypeScript dwingt te controleren of `T` alle paden uit de registry
 * bevat, zónder excess-property-checking. Extra sleutels (zoals parent-nodes met een
 * panel-component) zijn daardoor toegestaan.
 */
function createComponents<T extends Record<ExtractLeafPaths<typeof DASHBOARD_REGISTRY>, Type<unknown>>>(components: T): T {
	return components;
}

/**
 * Koppelt elke leaf node uit de DASHBOARD_REGISTRY aan het bijbehorende Angular-component.
 * Sleutel = volledige URL-segmenten samengevoegd met '/'.
 *
 * `createComponents(…)` garandeert dat elk pad uit de registry hier een entry heeft.
 * Extra sleutels (bijv. tussenknopen met een panel-component zoals `details/leerling`) zijn
 * toegestaan — de expliciete `Record<string, …>` annotatie zorgt daarvoor.
 *
 * Dit bestand wordt WEL door app.routes.ts geïmporteerd maar NIET door de admin-app
 * of buildscripts — het is het enige bestand dat Angular-componentreferenties bevat.
 */
export const DASHBOARD_COMPONENTS: Record<string, Type<unknown>> = createComponents({
	// onderwijsresultaten
	'onderwijsresultaten/onderwijsresultaten': OnderwijsresultatenComponent,
	'onderwijsresultaten/onderwijspositie': OnderwijspositieComponent,
	'onderwijsresultaten/onderbouwsnelheid': OnderbouwsnelheidComponent,
	'onderwijsresultaten/bovenbouwsucces': BovenbouwsuccesComponent,
	'onderwijsresultaten/examencijfers': ExamencijfersComponent,
	'onderwijsresultaten/verschil-se-ce': VerschilSeCeComponent,

	// prestatieanalyse
	'prestatieanalyse/prestatieanalyse': PrestatieanalyseComponent,
	'prestatieanalyse/behaald-niveau-conform-opp': BehaaldNiveauConformOPPComponent,
	'prestatieanalyse/beoogd-irt-behaald': BeoogdIrtBehaaldComponent,
	'prestatieanalyse/tussentijdse-uitstroom': TussentijdseUitstroomComponent,
	'prestatieanalyse/einduitstroom': EinduitstroomComponent,

	// cijfers
	'cijfers/overzicht': CijfersOverzichtComponent,
	'cijfers/docent': CijfersDocentComponent,
	'cijfers/toets': ToetsComponent,
	'cijfers/toets-details': ToetsDetailsComponent,
	'cijfers/se-ce': CijfersSeCeComponent,
	'cijfers/cijferlijst': CijferlijstComponent,
	'cijfers/examens': CijfersExamensComponent,

	// doorstroom – idu
	'doorstroom/idu/doorstroom': DoorstroomComponent,
	'doorstroom/idu/matrix': MatrixComponent,
	'doorstroom/idu/geslaagd': GeslaagdComponent,
	'doorstroom/idu/instroom': InstroomComponent,
	'doorstroom/idu/uitstroom': UitstroomComponent,
	'doorstroom/idu/overgang': OvergangComponent,

	// doorstroom – advies
	'doorstroom/advies/plaatsing': PlaatsingAdviesComponent,

	// doorstroom – cohort
	'doorstroom/cohort/rendement': CohortrendementComponent,
	'doorstroom/cohort/details': CohortdetailsComponent,

	// aanwezigheid
	'aanwezigheid/overzicht': AanwezigheidOverzichtComponent,
	'aanwezigheid/statistieken': AanwezigheidStatistiekenComponent,
	'aanwezigheid/datavolledigheid': AanwezigheidDatavolledigheidComponent,
	'aanwezigheid/afwezigheid': AfwezigheidComponent,
	'aanwezigheid/lesregistraties': LesregistratiesComponent,

	// leerling
	'leerling/leerling': LeerlingComponent,
	'leerling/kenmerk': KenmerkComponent,
	'leerling/vakken': VakkenComponent,

	// basisvaardigheden
	'basisvaardigheden/leesvaardigheid': BasisvaardigheidOverzichtComponent,
	'basisvaardigheden/taalverzorging': BasisvaardigheidOverzichtComponent,
	'basisvaardigheden/rekenen': BasisvaardigheidOverzichtComponent,

	// details – leerling
	'details/leerling': LeerlingDetailsPanelComponent,
	'details/leerling/doorstroom': LeerlingDoorstroomDetailsPanelComponent,
	'details/leerling/basisvaardigheden/leesvaardigheid': LeerlingBasisvaardighedenDetailsPanelComponent,
	'details/leerling/basisvaardigheden/taalverzorging': LeerlingBasisvaardighedenDetailsPanelComponent,
	'details/leerling/basisvaardigheden/rekenen': LeerlingBasisvaardighedenDetailsPanelComponent,
	'details/leerling/cijferlijst': LeerlingCijferlijstDetailsPanelComponent,
	'details/leerling/aanwezigheid': LeerlingAanwezigheidDetailsPanelComponent,
	'details/leerling/afwezigheid': LeerlingAfwezigheidDetailsPanelComponent,
	'details/leerling/afwezigheidsredenen': LeerlingAfwezigheidsredenenDetailsPanelComponent,
	'details/leerling/lesregistraties': LeerlingLesregistratiesDetailsPanelComponent,
	'details/leerling/lesregistratieredenen': LeerlingLesregistratieredenenDetailsPanelComponent,
	'details/leerling/vakken': LeerlingVakkenDetailsPanelComponent,

	// details – docent
	'details/docent': DocentDetailsPanelComponent,
	'details/docent/cijfers': DocentCijfersDetailsPanelComponent,
	'details/docent/toets': DocentToetsDetailsPanelComponent,

	// details – uitzondering
	'details/uitzondering/doorstroom': UitzonderingDoorstroomComponent,
	'details/uitzondering/onderbouwsnelheid': UitzonderingOnderbouwsnelheidComponent,
	'details/uitzondering/onderwijspositie': UitzonderingOnderwijspositieComponent,
	'details/uitzondering/bovenbouwsucces': UitzonderingBovenbouwsuccesComponent,
	'details/uitzondering/uitstroomniveau': UitzonderingUitstroomniveauComponent,
	'details/uitzondering/tussentijdse-uitstroom': UitzonderingTussentijdseUitstroomComponent,
	'details/uitzondering/einduitstroom': UitzonderingEinduitstroomComponent,
});
